import { useHasFocus } from '@axo/shared/ui/input/hooks/useHasFocus';
import DateDropdownUI, {
  IDateDropdownBase,
} from '@axo/shared/ui/input/lib/DateDropdown/DateDropdownUI';
import { Controller, useFormContext } from 'react-hook-form';
import { usePrimaryState, useReloadValue, useValidationUI } from '../../hooks';
import { IControlledField, IFormFields } from '../UI.types';

interface Props<Fields> extends IDateDropdownBase, IControlledField<Fields> {}

interface ExtendedProps<Fields> extends Props<Fields> {
  value: string;
  labelYearOnly?: string;
  onFocus?: () => void;
  onBlur?: () => void;
  onChange: (value: string | undefined) => void;
}

const DateInputWrapper = <Fields extends IFormFields>({
  name,
  successValidation,
  warningValidation,
  tooltipValidation,
  onChange,
  onBlur,
  value,
  ...dateInputProps
}: ExtendedProps<Fields>) => {
  const { hasFocus, ...useHasFocusEventHandlers } = useHasFocus({ onBlur });
  const { infoBox, isValidating } = useValidationUI({
    name,
    hasFocus,
    warningValidation,
    successValidation,
    tooltipValidation,
  });

  const primaryState = usePrimaryState({
    infoBoxType: infoBox?.type,
    isValidating,
    name,
    hasFocus,
  });

  // TODO fix for DK ... this is not working
  // `DropdownUI` already contains a `FormControl` component, and they can't be nested
  return (
    // <FormControl state={UIInputState[primaryState]}>
    //   <InputInfoBoxUI {...infoBox}>
    //     <InputStateBoxUI primaryState={primaryState}>
    <DateDropdownUI
      {...useHasFocusEventHandlers}
      onChange={onChange}
      value={value}
      state={primaryState}
      infoBox={infoBox}
      {...dateInputProps}
    />
    //     </InputStateBoxUI>
    //   </InputInfoBoxUI>
    // </FormControl>
  );
};

export const DateFieldUI = <Fields extends IFormFields>({
  name,
  rules,
  ...dateInputProps
}: Props<Fields>) => {
  const { control } = useFormContext();
  useReloadValue(name);

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field: { name, onChange, onBlur, value } }) => (
        <DateInputWrapper
          name={name}
          {...dateInputProps}
          onChange={onChange}
          onBlur={onBlur}
          value={value}
        />
      )}
    />
  );
};
